'use strict';

var iterateOverSparseArray = require('./iterateOverSparseArray');

function forEach(arr, fn) {
  for (var i = 0, len = arr.length; i < len; i++) {
    if (!(i in arr)) {
      return iterateOverSparseArray(arr, fn, i);
    }
    fn(arr[i], i);
  }
}

module.exports = forEach;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/forEach.js
// module id = 17
// module chunks = 1